import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions,URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable'; 
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { Angular2TokenService } from 'angular2-token';
import { AuthService } from '../../../authentication/auth.service';
import { environment } from 'environments/environment';

@Injectable()
export class CategoryService {

	options: RequestOptions;

	constructor(
		private http: Http,
    	private tokenService: Angular2TokenService,
    	private authService: AuthService
	) {
		this.options = this.authService.getHeaders();
	}

    private extractDataPage(res:Response){
        return res;
    }

	private extractData(res: Response) {
      let body = res.json();
      return body;
    }

    private handleErrorObservable (error: Response | any) {
      return Observable.throw(error.message || error);
    }

    addbrand(data){
    	var url = environment.apiBaseUrl+'/v1/brands';
    	 return this.http.post(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    listbrands(){
    	var url = environment.apiBaseUrl+'/v1/brands';
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    updateBrand(data, brandId){
    	var url = environment.apiBaseUrl+'/v1/brands/'+brandId;
    	 return this.http.patch(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

   	deleteBrand(brandId){
    	var url = environment.apiBaseUrl+'/v1/brands/'+brandId;
    	 return this.http.delete(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    getDetailsOfBrand(brandId){
    	var url = environment.apiBaseUrl+'/v1/brands/'+brandId;
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    addCoreMateial(data){
    	var url = environment.apiBaseUrl+'/v1/core_materials';
    	 return this.http.post(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    listCoreMateial(){
    	var url = environment.apiBaseUrl+'/v1/core_materials';
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    updateCoreMaterials(data, materialId){
    	var url = environment.apiBaseUrl+'/v1/core_materials/'+materialId;
    	 return this.http.patch(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

   	deleteCoreMaterials(materialId){
    	var url = environment.apiBaseUrl+'/v1/core_materials/'+materialId;
    	 return this.http.delete(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    getDetailsOfCoreMaterials(materialId){
    	var url = environment.apiBaseUrl+'/v1/core_materials/'+materialId;
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    addShutter_finishes(data){
    	var url = environment.apiBaseUrl+'/v1/shutter_finishes';
    	 return this.http.post(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    listShutter_finishes(){
    	var url = environment.apiBaseUrl+'/v1/shutter_finishes';
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    updateShutter_finishes(data, id){
    	var url = environment.apiBaseUrl+'/v1/shutter_finishes/'+id;
    	 return this.http.patch(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

   	deleteShutter_finishes(id){
    	var url = environment.apiBaseUrl+'/v1/shutter_finishes/'+id;
    	 return this.http.delete(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    getDetailsOfShutter_finishes(id){
    	var url = environment.apiBaseUrl+'/v1/shutter_finishes/'+id;
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    addShades(data){
    	var url = environment.apiBaseUrl+'/v1/shades';
    	 return this.http.post(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    listShades(){
    	var url = environment.apiBaseUrl+'/v1/shades';
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    updateShades(data, id){
    	var url = environment.apiBaseUrl+'/v1/shades/'+id;
    	 return this.http.patch(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

   	deleteShades(id){
    	var url = environment.apiBaseUrl+'/v1/shades/'+id;
    	 return this.http.delete(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    getDetailsOfShades(id){
    	var url = environment.apiBaseUrl+'/v1/shades/'+id;
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    addSkirting_configs(data){
    	var url = environment.apiBaseUrl+'/v1/skirting_configs';
    	 return this.http.post(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    listSkirting_configs(){
    	var url = environment.apiBaseUrl+'/v1/skirting_configs';
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    updateSkirting_configs(data, id){
    	var url = environment.apiBaseUrl+'/v1/skirting_configs/'+id;
    	 return this.http.patch(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

   	deleteSkirting_configs(id){
    	var url = environment.apiBaseUrl+'/v1/skirting_configs/'+id;
    	 return this.http.delete(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    getDetailsOfSkirting_configs(id){
    	var url = environment.apiBaseUrl+'/v1/skirting_configs/'+id;
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    addModule_types(data){
    	var url = environment.apiBaseUrl+'/v1/module_types';
    	 return this.http.post(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    listModule_types(){
    	var url = environment.apiBaseUrl+'/v1/module_types';
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    updateModule_types(data, id){
    	var url = environment.apiBaseUrl+'/v1/module_types/'+id;
    	 return this.http.patch(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

   	deleteModule_types(id){
    	var url = environment.apiBaseUrl+'/v1/module_types/'+id;
    	 return this.http.delete(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    getDetailsOfModule_types(id){
    	var url = environment.apiBaseUrl+'/v1/module_types/'+id;
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }
    addhandles(data){
    	var url = environment.apiBaseUrl+'/v1/handles';
    	 return this.http.post(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    listhandles(){
    	var url = environment.apiBaseUrl+'/v1/handles';
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    updatehandles(data, id){
    	var url = environment.apiBaseUrl+'/v1/handles/'+id;
    	 return this.http.patch(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

   	deletehandles(id){
    	var url = environment.apiBaseUrl+'/v1/handles/'+id;
    	 return this.http.delete(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    getDetailsOfhandles(id){
    	var url = environment.apiBaseUrl+'/v1/handles/'+id;
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    addhardware_types(data){
    	var url = environment.apiBaseUrl+'/v1/hardware_types';
    	 return this.http.post(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    listhardware_types(){
    	var url = environment.apiBaseUrl+'/v1/hardware_types';
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    listCategoryFilteredhardware_types(category){
        var url = environment.apiBaseUrl+'/v1/hardware_types?category='+category;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updatehardware_types(data, id){
    	var url = environment.apiBaseUrl+'/v1/hardware_types/'+id;
    	 return this.http.patch(url,data,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

   	deletehardware_types(id){
    	var url = environment.apiBaseUrl+'/v1/hardware_types/'+id;
    	 return this.http.delete(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    getDetailsOfhardware_types(id){
    	var url = environment.apiBaseUrl+'/v1/hardware_types/'+id;
    	return this.http.get(url,this.options)
    	 			.map(this.extractData)
    	 			.catch(this.handleErrorObservable);
    }

    // Hardware Elements

    addhardware_elements(data){
        var url = environment.apiBaseUrl+'/v1/hardware_elements';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listhardware_elements(){
        var url = environment.apiBaseUrl+'/v1/hardware_elements';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updatehardware_elements(data, id){
        var url = environment.apiBaseUrl+'/v1/hardware_elements/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

       deletehardware_elements(id){
        var url = environment.apiBaseUrl+'/v1/hardware_elements/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfhardware_elements(id){
        var url = environment.apiBaseUrl+'/v1/hardware_elements/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    // Carcass Elements

    addcarcass_elements(data){
        var url = environment.apiBaseUrl+'/v1/carcass_elements';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listcarcass_elements(){
        var url = environment.apiBaseUrl+'/v1/carcass_elements';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updatecarcass_elements(data, id){
        var url = environment.apiBaseUrl+'/v1/carcass_elements/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

       deletecarcass_elements(id){
        var url = environment.apiBaseUrl+'/v1/carcass_elements/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfcarcass_elements(id){
        var url = environment.apiBaseUrl+'/v1/carcass_elements/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    addaddon(data){
        var url = environment.apiBaseUrl+'/v1/addons';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listaddons(){
        var url = environment.apiBaseUrl+'/v1/addons';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateaddon(data, id){
        var url = environment.apiBaseUrl+'/v1/addons/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteaddon(id){
        var url = environment.apiBaseUrl+'/v1/addons/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfaddon(id){
        var url = environment.apiBaseUrl+'/v1/addons/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    addcombinedDoor(data){
        var url = environment.apiBaseUrl+'/v1/combined_doors';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listCombined_doors(){
        var url = environment.apiBaseUrl+'/v1/combined_doors';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateCombined_door(data, id){
        var url = environment.apiBaseUrl+'/v1/combined_doors/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteCombined_door(id){
        var url = environment.apiBaseUrl+'/v1/combined_doors/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfCombined_door(id){
        var url = environment.apiBaseUrl+'/v1/combined_doors/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }
    
    addHardware_element_types(data){
        var url = environment.apiBaseUrl+'/v1/hardware_element_types';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listHardware_element_types(){
        var url = environment.apiBaseUrl+'/v1/hardware_element_types';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listCategoryFilteredHardware_element_types(category){
        var url = environment.apiBaseUrl+'/v1/hardware_element_types?category='+category;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateHardware_element_types(data, id){
        var url = environment.apiBaseUrl+'/v1/hardware_element_types/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteHardware_element_types(id){
        var url = environment.apiBaseUrl+'/v1/hardware_element_types/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfHardware_elemtype(id){
        var url = environment.apiBaseUrl+'/v1/hardware_element_types/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    addCarcass_element_types(data){
        var url = environment.apiBaseUrl+'/v1/carcass_element_types';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listCarcass_element_types(){
        var url = environment.apiBaseUrl+'/v1/carcass_element_types';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateCarcass_element_types(data, id){
        var url = environment.apiBaseUrl+'/v1/carcass_element_types/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteCarcass_element_types(id){
        var url = environment.apiBaseUrl+'/v1/carcass_element_types/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listCarcass_elements(category){
        var url = environment.apiBaseUrl+'/v1/carcass_elements?category='+category;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listHardware_elements(category){
        var url = environment.apiBaseUrl+'/v1/hardware_elements?category='+category;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfCarcass_elemtype(id){
        var url = environment.apiBaseUrl+'/v1/carcass_element_types/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    addCategories(data){
        var url = environment.apiBaseUrl+'/v1/kitchen_categories';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listCategories(){
        var url = environment.apiBaseUrl+'/v1/kitchen_categories';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateCategories(data, id){
        var url = environment.apiBaseUrl+'/v1/kitchen_categories/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteCategories(id){
        var url = environment.apiBaseUrl+'/v1/kitchen_categories/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    addCoreMaterialPrices(data){
        var url = environment.apiBaseUrl+'/v1/core_material_prices';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listCoreMaterialPrices(){
        var url = environment.apiBaseUrl+'/v1/core_material_prices';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateCoreMaterialPrices(data, id){
        var url = environment.apiBaseUrl+'/v1/core_material_prices/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteCoreMaterialPrices(id){
        var url = environment.apiBaseUrl+'/v1/core_material_prices/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfCategories(id){
        var url = environment.apiBaseUrl+'/v1/kitchen_categories/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    addCustomElement(data){
        var url = environment.apiBaseUrl+'/v1/custom_elements';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listCustomElement(){
        var url = environment.apiBaseUrl+'/v1/custom_elements';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateCustomElement(data, id){
        var url = environment.apiBaseUrl+'/v1/custom_elements/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteCustomElement(id){
        var url = environment.apiBaseUrl+'/v1/custom_elements/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfCustomElement(id){
        var url = environment.apiBaseUrl+'/v1/custom_elements/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    shadesShutterFinishMapping(){
      var mappingUrl = environment.apiBaseUrl+'/v1/shutter_finishes/shades_mapping';
      return this.http.get(mappingUrl,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    coreMaterialShutterFinishMapping(){
      var mappingUrl = environment.apiBaseUrl+'/v1/shutter_finishes/core_material_mapping';
      return this.http.get(mappingUrl,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    moduleAddonsMapping(){
      var mappingUrl = environment.apiBaseUrl+'/v1/product_modules/addons_mapping';
      return this.http.get(mappingUrl,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    kitchenAddonsMapping(product_module_id){
      var mappingUrl = environment.apiBaseUrl+'/v1/product_modules/'+product_module_id+'/kitchen_module_addon';
      return this.http.get(mappingUrl,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    kitchenModuleMapping(){
      var mappingUrl = environment.apiBaseUrl+'/v1/kitchen_categories/kitchen_module_mapping';
      return this.http.get(mappingUrl,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    fetchShades(){
      var shadesUrl = environment.apiBaseUrl+'/v1/shades';
      return this.http.get(shadesUrl,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    fetchShutter(){
      var shutterUrl = environment.apiBaseUrl+'/v1/shutter_finishes';
      return this.http.get(shutterUrl,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    fetchAddon(category = null){
      if(category == null){
        var addonUrl = environment.apiBaseUrl+'/v1/addons';
      }
      else{
        var addonUrl = environment.apiBaseUrl+'/v1/addons?category='+category;
      }
      return this.http.get(addonUrl,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    fetchModuleType(category = "kitchen"){
      var moduleTypeUrl = environment.apiBaseUrl+'/v1/module_types?category='+category;
      return this.http.get(moduleTypeUrl,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    fetchProductModule(category){
      var moduleTypeUrl = environment.apiBaseUrl+'/v1/product_modules?category='+category;
      return this.http.get(moduleTypeUrl,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    submitMapping(obj, active_selection){
      if(active_selection=="shades_shutter_finish"){
        var url = environment.apiBaseUrl+'/v1/shutter_finishes/shades_mapping';
      }
      else if(active_selection=="core_material_shutter"){
        var url = environment.apiBaseUrl+'/v1/shutter_finishes/core_material_mapping';
      }

      else if(active_selection=="module_addons"){
        var url = environment.apiBaseUrl+'/v1/product_modules/addons_mapping';
      }
      else if(active_selection=="kitchen_category_module_type"){
        var url = environment.apiBaseUrl+'/v1/kitchen_categories/kitchen_module_mapping';
      }

      else if(active_selection == "kitchen_module_addons"){
        var url = environment.apiBaseUrl+'/v1/product_modules/kitchen_module_addon';
      }
      return this.http.post(url,obj,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    createModule(data){
        var url = environment.apiBaseUrl+'/v1/product_modules';
        var obj = {
            "product_module": data
        }
        return this.http.post(url,obj,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);

    }

    listModules(){
        var url = environment.apiBaseUrl+'/v1/product_modules';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateModules(data, id){
        var url = environment.apiBaseUrl+'/v1/product_modules/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteModules(id){
        var url = environment.apiBaseUrl+'/v1/product_modules/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }


    //  method to get wip projects for category role
    getWipProjectList(){

        var url = environment.apiBaseUrl+'/v1/users/wip_leads_for_category';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);

    }


    getApprovedBoqList(projectId,proposal_type){
        var url = environment.apiBaseUrl+'/v1/proposals/category_boqs_of_project?project_id='+projectId+'&proposal_type='+proposal_type;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);


    }

    listEdgebandingShades(){
        var url = environment.apiBaseUrl+'/v1/edge_banding_shades';
        return this.http.get(url,this.options)
                    .map(this.extractData)
                    .catch(this.handleErrorObservable);
    }

    addEdgebandingShades(data){
        var url = environment.apiBaseUrl+'/v1/edge_banding_shades';
         return this.http.post(url,data,this.options)
                    .map(this.extractData)
                    .catch(this.handleErrorObservable);
    }

    updateEdgebandingShades(data, id){
        var url = environment.apiBaseUrl+'/v1/edge_banding_shades/'+id;
         return this.http.patch(url,data,this.options)
                    .map(this.extractData)
                    .catch(this.handleErrorObservable);
    }

    deleteEdgebandingShades(id){
        var url = environment.apiBaseUrl+'/v1/edge_banding_shades/'+id;
         return this.http.delete(url,this.options)
                    .map(this.extractData)
                    .catch(this.handleErrorObservable);
    }

    getDetailsOfEdgebandingShades(id){
        var url = environment.apiBaseUrl+'/v1/edge_banding_shades/'+id;
        return this.http.get(url,this.options)
                .map(this.extractData)
                .catch(this.handleErrorObservable);
    }
    getCustomElements(projectId){
        var url = environment.apiBaseUrl+'/v1/projects/'+projectId+'/custom_elements';
        return this.http.get(url,this.options)
                .map(this.extractData)
                .catch(this.handleErrorObservable);

    }
    addCustomPrice(data,customId,projectId){
         var url = environment.apiBaseUrl+'/v1/projects/'+projectId+'/custom_elements/'+customId+'/add_custom_element_price';
       
        return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);

    }

    addServiceCategory(data){
        var url = environment.apiBaseUrl+'/v1/service_categories';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listService_categories(){
        var url = environment.apiBaseUrl+'/v1/service_categories';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateService_categories(data, id){
        var url = environment.apiBaseUrl+'/v1/service_categories/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteService_categories(id){
        var url = environment.apiBaseUrl+'/v1/service_categories/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfService_categories(id){
        var url = environment.apiBaseUrl+'/v1/service_categories/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    addService_subcategories(data){
        var url = environment.apiBaseUrl+'/v1/service_subcategories';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listService_subcategories(service_category_id?){
        var url = environment.apiBaseUrl+'/v1/service_subcategories?service_category_id='+service_category_id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateService_subcategories(data, id){
        var url = environment.apiBaseUrl+'/v1/service_subcategories/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteService_subcategories(id){
        var url = environment.apiBaseUrl+'/v1/service_subcategories/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfService_subcategories(id){
        var url = environment.apiBaseUrl+'/v1/service_subcategories/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    addService_activities(data){
        var url = environment.apiBaseUrl+'/v1/service_activities';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listService_activities(){
        var url = environment.apiBaseUrl+'/v1/service_activities';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateService_activities(data, id){
        var url = environment.apiBaseUrl+'/v1/service_activities/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteService_activities(id){
        var url = environment.apiBaseUrl+'/v1/service_activities/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfService_activities(id){
        var url = environment.apiBaseUrl+'/v1/service_activities/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    addKitchen_appliances(data){
        var url = environment.apiBaseUrl+'/v1/kitchen_appliances';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listKitchen_appliances(){
        var url = environment.apiBaseUrl+'/v1/kitchen_appliances';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateKitchen_appliances(data, id){
        var url = environment.apiBaseUrl+'/v1/kitchen_appliances/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteKitchen_appliances(id){
        var url = environment.apiBaseUrl+'/v1/kitchen_appliances/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfKitchen_appliances(id){
        var url = environment.apiBaseUrl+'/v1/kitchen_appliances/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getModuletypeForKitchen_appliances(){
        var url = environment.apiBaseUrl+'/v1/module_types/appliance_types';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    fetchFloorplan(project_id){
        var url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/floorplans';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    fetchCad(project_id){
        var url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/cad_drawings';
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    listaddontags(){
        var url = environment.apiBaseUrl+'/v1/tags';
         return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    addAddontags(data){
        var url = environment.apiBaseUrl+'/v1/tags';
         return this.http.post(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }
    updateAddontags(data, id){
        var url = environment.apiBaseUrl+'/v1/tags/'+id;
         return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deleteAddontags(id){
        var url = environment.apiBaseUrl+'/v1/tags/'+id;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    getDetailsOfAddontags(id){
        var url = environment.apiBaseUrl+'/v1/tags/'+id;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    updateAddontagOfAddon(data,addonid){
        var url = environment.apiBaseUrl+'/v1/addons/'+addonid+'/update_tags';
        return this.http.patch(url,data,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }
    getVendorCategories(){
        var url = environment.apiBaseUrl+'/v1/vendors/get_vendor_categories';
         return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable); 
    }
    getSubcategoryList(value){
      var url = environment.apiBaseUrl+'/v1/vendors/get_vendor_sub_categories?parent_category_id='+value;
         return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable); 
    }
    getCities(){
       var url = environment.apiBaseUrl+'/v1/cities';
         return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);  
    }
    postVendorForm(data,basefile_pan,basefile_gst,basefile_cheque){
        data['pan_copy'] = basefile_pan;
        data['gst_copy'] = basefile_gst;
        data['cancelled_cheque'] = basefile_cheque;
        var obj ={
            "vendor": data,
            "sub_category_ids": data['sub_category_ids'],
            "serviceable_city_ids": data['serviceable_city_ids'] 
        }
        var url = environment.apiBaseUrl+'/v1/vendors';
         return this.http.post(url,obj,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);

    }
    deleteVendor(vendorId){
        var url = environment.apiBaseUrl+'/v1/vendors/'+vendorId;
         return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);

    }

    getVendorList(page?,search?){
        var url = environment.apiBaseUrl+'/v1/vendors';
         var params: URLSearchParams = new URLSearchParams();
         params.set('search', search);
         params.set('page',page);
         var opt = this.options;
         opt.search = params;
         return this.http.get(url,opt)
                     .map(this.extractDataPage)
                     .catch(this.handleErrorObservable);

    }
    getVendorDetails(value){
        var url = environment.apiBaseUrl+'/v1/vendors/'+value;

         return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);

    }
    postUpdateVendorForm(vendorId,data,basefile_pan,basefile_gst,basefile_cheque){
        data['pan_copy'] = basefile_pan;
        data['gst_copy'] = basefile_gst;
        data['cancelled_cheque'] = basefile_cheque;
        var obj ={
            "vendor": data,
            "sub_category_ids": data['sub_category_ids'],
            "serviceable_city_ids": data['serviceable_city_ids'] 
        }
        var url = environment.apiBaseUrl+'/v1/vendors/'+vendorId;
         return this.http.patch(url,obj,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);

    }
    getCityListByFilterCities(city,value){
        var url = environment.apiBaseUrl+'/v1/vendors?filter_by_type='+city+'&filter_by_id='+value;

         return this.http.get(url,this.options)
                     .map(this.extractDataPage)
                     .catch(this.handleErrorObservable);

    }
    getCategoryListByStatus(cat,value){
       var url = environment.apiBaseUrl+'/v1/vendors?filter_by_type='+cat+'&filter_by_id='+value;

         return this.http.get(url,this.options)
                     .map(this.extractDataPage)
                     .catch(this.handleErrorObservable); 

    }
    getSubCategoryListByStatus(cat,value){
       var url = environment.apiBaseUrl+'/v1/vendors?filter_by_type='+cat+'&filter_by_id='+value;

         return this.http.get(url,this.options)
                     .map(this.extractDataPage)
                     .catch(this.handleErrorObservable); 

    }
    getVendorPage(size){
        var url = environment.apiBaseUrl+'/v1/vendors?page_size='+size;

         return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable); 

    }
    fetchBoqList(project_id){
      let url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/boq_and_ppt_uploads/get_boqs';

      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    } 
    fetchPptList(project_id){
      let url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/boq_and_ppt_uploads/get_ppts';

      return this.http.get(url,this.options)
              .map(this.extractData)
              .catch(this.handleErrorObservable);
    } 

    filteredVendors(search_string,category_id,sub_category_id,serviceable_city_id){
        var filterobj = {
            'category_id':category_id,
            'sub_category_id':sub_category_id,
            'serviceable_city_id':serviceable_city_id
        }
        var filterstr ='&filter_params='+JSON.stringify(filterobj);
        var url = environment.apiBaseUrl+'/v1/vendors/index_new?search_string='+search_string+filterstr;
         return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable); 
    }
    /* GET all the job_elements of a BOQ line item*/
    getjob_elements_of_BOQlineitem(project_id,quotation_id,ownerable_type,ownerable_id){
       var url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/quotations/'+quotation_id+
       '/job_elements/index_by_job?ownerable_type='+ownerable_type+'&ownerable_id='+ownerable_id;
         return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable); 

    }
    postjob_elements_of_BOQlineitem(project_id,quotation_id,ownerable_type,ownerable_id,formval){
       var url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/quotations/'+quotation_id+
       '/job_elements';
       var obj = {
            'job_element': {
                'element_name':formval.element_name,
                'ownerable_type': ownerable_type,
                'ownerable_id': ownerable_id
            }
        }
        return this.http.post(url,obj,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable); 
    }
    deletejob_elements_of_BOQlineitem(project_id,quotation_id,jobelemid){
        var url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/quotations/'+quotation_id+'/job_elements/'+jobelemid;
        return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable); 
    }

    updatejob_elements_of_BOQlineitem(project_id,quotation_id,jobelemid,ownerable_type,ownerable_id,updatedval){
        var obj = {
            'job_element': {
                'element_name':updatedval,
                'ownerable_type': ownerable_type,
                'ownerable_id': ownerable_id
            }
        }
        var url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/quotations/'+quotation_id+'/job_elements/'+jobelemid;
        return this.http.patch(url,obj,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable); 
    }

    getDeatils_of_job_elements_of_BOQlineitem(project_id,quotation_id,jobelemid){
        var url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/quotations/'+quotation_id+'/job_elements/'+jobelemid;
        return this.http.get(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable); 
    }

    addvendorToLineitem(project_id,quotation_id,jobelemid,obj){
        var url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/quotations/'+quotation_id+'/job_elements/'+jobelemid+'/add_vendor';
        return this.http.post(url,obj,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

    deletevendorToLineitem(project_id,quotation_id,jobelemid,vendor_id){
        var url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/quotations/'+quotation_id+'/job_elements/'+
        jobelemid+'/remove_vendor?vendor_id='+vendor_id;
        return this.http.delete(url,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }
    updatevendorToLineitem(project_id,quotation_id,jobelemid,obj,vendor_id){
        var url = environment.apiBaseUrl+'/v1/projects/'+project_id+'/quotations/'+quotation_id
        +'/job_elements/'+jobelemid+'/update_vendor_details?vendor_id='+vendor_id;
        return this.http.patch(url,obj,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }
    
    // get quotations for po
    getQuotationsList(){
        var url = environment.apiBaseUrl+'/v1/projects/quotations_for_po';
        return this.http.get(url, this.options)
                    .map(this.extractData)
                    .catch(this.handleErrorObservable);
    }

    lineItemDetails(quotation_id){
        var url = environment.apiBaseUrl+'/v1/purchase_orders/line_items_for_po?quotation_id='+quotation_id;
        return this.http.get(url, this.options)
                    .map(this.extractData)
                    .catch(this.handleErrorObservable);
    }
    
    createPurchaseOrder(milestone_elements, shipping_address, job_element_vendor_id, quotation_id, project_id){
        var obj = {
            'purchase_order': {
                'quotation_id': quotation_id,
                'project_id': project_id,
                'job_element_vendor_id': job_element_vendor_id,
                'shipping_address': shipping_address,
            },
            milestone_elements
        }
        var url = environment.apiBaseUrl+'/v1/purchase_orders/';
        return this.http.post(url,obj,this.options)
                     .map(this.extractData)
                     .catch(this.handleErrorObservable);
    }

}	



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/category/category/category.service.ts